import { render, staticRenderFns } from "./PaymentField.vue?vue&type=template&id=cbd470b8"
import script from "./PaymentField.vue?vue&type=script&lang=js"
export * from "./PaymentField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports